<template>
    <div class="container-fluid mb-5 ps-5">
        <div class="row">
            <div class="col">
                <img @click="$emit('go-back-event')" src="../../assets/back-button.svg" class="img-fluid cursor-pointer" width="32" alt="">
            </div>
        </div>
    </div>
    <div class="custom-container">
        <div class="row mb-3">
            <div class="col">
                <p class="thin-text mb-3 fs-1">La vita è fatta di scelte, momenti di grande intensità, sogni da realizzare ed obiettivi da raggiungere. Progetti che ci coinvolgono in prima persona o che riguardano i nostri cari, passaggi di vita da condividere e a cui contribuire in modo attivo.</p>
                <p class="thin-text mb-3 fs-1">BG INSIEME Progetti di Vita è un piano di accumulo assicurativo totalmente personalizzato nelle modalità di costruzione e nelle possibilità di variazione, diverso da ogni altro perché può essere finalizzato a premiare il raggiungimento di importanti traguardi di vita.</p>
                <p class="thin-text mb-3 fs-1">BG INSIEME Progetti di Vita, unisce risparmio e protezione per pianificare i diversi traguardi e sostenere gli impegni economici che ne derivano. Puoi scegliere i progetti di vita da realizzare, per te o per i tuoi cari, come il conseguimento del diploma o della laurea, il matrimonio, la nascita di un figlio o il raggiungimento di una determinata età.</p>
                <p class="thin-text mb-3 fs-1">BG INSIEME Progetti di Vita è una formula avanzata di investimento che affianca ai vantaggi propri di un’assicurazione caratteristiche uniche, in grado di adeguarsi all’imprevedibilità della vita, alle necessità future o a nuove ambizioni.</p>
            </div>
        </div>
        <div class="row">
            <div class="text-center mb-3">
                <input @click="$emit('go-to-event', 'PathSelectionScreenId')" type="submit" value="Procedi">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'InfoScreen',
        emits: ['go-to-event', 'go-back-event'],
    }
</script>